import React from 'react';

import licenceKeyNames from '../../../services/ui/licenceKeyNames';

export default class LicenceServiceList extends React.Component {

    render() {

        const { serviceLicences } = this.props;

        return (
            <ul>

                {serviceLicences.map(serviceLicence => {

                    return (
                        <li key={serviceLicence.id}>
                            { serviceLicence.service.name } ({ licenceKeyNames[serviceLicence.licence_type] })
                        </li>
                    )
                })}

            </ul>
        )
    }
}
